import { render, staticRenderFns } from "./BaseUsersAdmin.vue?vue&type=template&id=8e1cb31a"
import script from "./BaseUsersAdmin.vue?vue&type=script&lang=js"
export * from "./BaseUsersAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports